import { openDB } from "idb";

const DB_NAME = "sendproof-offline";
let _db;

function db() {
  if (!_db) {
    _db = openDB(DB_NAME, 1, {
      upgrade(d) {
        if (!d.objectStoreNames.contains("outbox")) d.createObjectStore("outbox", { keyPath: "id" });
        if (!d.objectStoreNames.contains("cache")) d.createObjectStore("cache", { keyPath: "url" });
        if (!d.objectStoreNames.contains("blobs")) d.createObjectStore("blobs", { keyPath: "id" });
        if (!d.objectStoreNames.contains("kv")) d.createObjectStore("kv", { keyPath: "k" });
      },
    });
  }
  return _db;
}

/* ---------- read-through cache (GET payloads) ---------- */
export async function cachePut(url, data) { try { (await db()).put("cache", { url, data, at: Date.now() }); } catch { /* ignore */ } }
export async function cacheGet(url) { try { const r = await (await db()).get("cache", url); return r ? r.data : undefined; } catch { return undefined; } }

/* ---------- queued photo blobs ---------- */
export async function blobPut(id, blob) { (await db()).put("blobs", { id, blob }); }
export async function blobGet(id) { const r = await (await db()).get("blobs", id); return r ? r.blob : null; }
export async function blobDel(id) { try { (await db()).delete("blobs", id); } catch { /* ignore */ } }

/* ---------- outbox (queued mutations) ---------- */
export async function outboxAdd(e) { (await db()).put("outbox", e); }
export async function outboxAll() { const all = await (await db()).getAll("outbox"); return all.sort((a, b) => a.seq - b.seq); }
export async function outboxDel(id) { try { (await db()).delete("outbox", id); } catch { /* ignore */ } }

/* ---------- clear per-user data on auth change (prevents one account's
   cached reads/photos flashing into another account on the same device) ---------- */
export async function clearOfflineData({ keepOutbox = false } = {}) {
  try {
    const d = await db();
    await d.clear("cache");
    await d.clear("blobs");
    await d.clear("kv");
    if (!keepOutbox) await d.clear("outbox");
  } catch { /* ignore */ }
}

/* ---------- tiny kv (temp-id remap etc.) ---------- */
export async function kvGet(k) { try { const r = await (await db()).get("kv", k); return r ? r.v : undefined; } catch { return undefined; } }
export async function kvPut(k, v) { try { (await db()).put("kv", { k, v }); } catch { /* ignore */ } }
